var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.825 12.8418L10 9.02513L6.175 12.8418L5 11.6668L10 6.6668L15 11.6668L13.825 12.8418Z",
    fill: "#DEDFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomContract);
export default __webpack_public_path__ + "static/media/zoom_contract.e0cc0e1aa9cca45900cee8bf94e56471.svg";
export { ForwardRef as ReactComponent };